import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeZoneAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_ZONE),
    switchMap(action =>
      ZoneService.delete(action.zone.zoneId, store).pipe(
        map(() => removeZoneAction(action.zone)),
        catchError(retryAuthentication(action$, 'epics/zones/deleteZone'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/zones/deleteZone.js